module.exports = __webpack_public_path__ + "static/media/noData.3a761487.svg";